import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
`

export const GuestCopyrightContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${Media.AbovePhone`
    margin-right: 32px;
  `}
`

export const GuestCopyrightContent = styled.div`
  color: ${Colors.Neutral50};
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.3px;

  a {
    color: ${Colors.Blue50};
  }

  a:hover {
    color: ${Colors.Blue70};
  }
`
